import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDHsVKJ9_jKdVhozC8VTzyfaII58-vJCGs',
  authDomain: 'fotballyst.firebaseapp.com',
  projectId: 'fotballyst',
  storageBucket: 'fotballyst.appspot.com',
  messagingSenderId: '507438811454',
  appId: '1:507438811454:web:9d9298e800fef435df046f',
};

initializeApp(firebaseConfig);

export const db = getFirestore();
